import { ROUTE_NAMES_AGENT_STUDIO_CHAT_SIMULATOR } from '@atlassian/jira-common-constants/src/spa-routes.tsx';
import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types';

export const agentStudioChatSimulatorRoute: InvariantRoute = {
	name: ROUTE_NAMES_AGENT_STUDIO_CHAT_SIMULATOR,
	path: '/jira/support-center/settings/agent-studio/simulator',
	exact: true,
};
